import { FormGroup, FormControl,Validators } from '@angular/forms';
import { Component, Input, Optional, Host } from '@angular/core';
import { SatPopover } from '@ncstate/sat-popover';

@Component({
  selector: 'app-inline-contactos',  
  styleUrls: ['./inline-contactos.component.scss'],
  template: `
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="mat-subheading-2">Asignar Correo</div>
    <mat-form-field class="example-full-width">
                                    <mat-label>Correo</mat-label>
                                    <mat-select formControlName = "Contacto">
                                        <mat-option  *ngFor="let dato of contactos" [value]="dato.Correo">
                                            {{dato.Correo}}
                                        </mat-option>
                                    </mat-select>
   </mat-form-field>

    <div class="actions">
      <button mat-button type="button" color="primary" (click)="onCancel()">Cancelar</button>
      <button mat-button type="submit" color="primary" [disabled]="form.invalid">Guardar</button>
    </div>
  </form>
`
})
export class InlineContactosComponent{

  @Input()
    get value(): string { return this._value; }
    set value(x: string) {}
    private _value = '';
    form: FormGroup;

    @Input() contactos : any=[];

    constructor(@Optional() @Host()
    public popover: SatPopover) {

     this.form = new FormGroup({
       "Contacto" :new FormControl("",Validators.required),
     });
     }

  onSubmit() {
    if (this.popover) {
      this.popover.close(this.form.controls['Contacto'].value);
    }
  }

  onCancel() {
    if (this.popover) {
      this.popover.close();
    }
  }
}
